import { Controller } from 'stimulus';
import gsap from 'gsap';

class Actions extends Controller {
  connect() {
    this.header = document.querySelector('.header');

    this.buttonWrapper = this.buttonTarget.parentNode;

    this.calculateDimensions();
  }

  calculateDimensions() {
    const headerRect = this.header.getBoundingClientRect();
    const buttonWrapperComputedStyle = window.getComputedStyle(this.buttonWrapper);
    const buttonBoundingClientRect = this.buttonWrapper.getBoundingClientRect();

    this.topOffsetOfHeader = headerRect.top;
    this.bottomOffsetOfHeader = headerRect.top + headerRect.height + 16;
    this.buttonWrapperPaddingRight = parseInt(buttonWrapperComputedStyle.paddingRight, 10);
    this.buttonWrapperPaddingTop = parseInt(buttonWrapperComputedStyle.paddingTop, 10);

    this.buttonWrapper.style.minHeight = `${buttonBoundingClientRect.height}px`;
  }

  onWindowResize() {
    this.calculateDimensions();
  }

  onWindowScroll() {
    const buttonRect = this.buttonWrapper.getBoundingClientRect();
    const buttonTop = buttonRect.top + this.buttonWrapperPaddingTop;

    gsap.to(this.header, {
      autoAlpha: buttonTop < this.bottomOffsetOfHeader ? 0 : 1,
      duration: 0.1,
    });

    // If the button is hitting the top of the header,
    // make it stick to the top.
    if (buttonTop < this.topOffsetOfHeader) {
      this.buttonTarget.style.position = 'fixed';
      this.buttonTarget.style.top = `${this.topOffsetOfHeader}px`;
      // The element is a .grid element with paddings. If we set 0, it would align
      // to the outer edge.
      this.buttonTarget.style.right = `${this.buttonWrapperPaddingRight}px`;
    } else {
      this.buttonTarget.style.position = 'static';
    }
  }
}

Actions.targets = [
  'button',
];

export default Actions;
